import type { Amount } from '@morpho-org/dapp-core'

/**
 * Adds two optional USD amounts, staying `undefined` when either side has no
 * price.
 *
 * Used when merging reward rows that share a token. The merge key is the token
 * address alone, so records from different chains — or with different metadata —
 * collapse into one row and can disagree on whether a price is available.
 *
 * Coercing the missing side to `0n` would leave a defined-but-understated
 * total, which reads as fully priced downstream: `isRewardSumFullyPriced` could
 * no longer tell a partially-priced row from a complete one. It also threw a
 * `TypeError` (BigInt mixing) whenever the *first* record was the unpriced one,
 * since `undefined + 0n` is not a valid addition.
 *
 * `Token.toUsd` signals "no price" with `undefined`, but `Amount` is typed
 * `bigint | null`, so both nullish forms are treated as missing.
 */
export const addOptionalUsd = (a: Amount | undefined, b: Amount | undefined): Amount | undefined =>
  a == null || b == null ? undefined : a + b
